import { ApiType } from "@gymflow/common";
import { useMutation } from "@tanstack/react-query";

export const useMutationCreateUser = ({ api }: { api: ApiType }) => {
  return useMutation({
    mutationFn: async (
      values: Parameters<ApiType["memberApi"]["createUser"]>[0],
    ) => {
      return (await api.memberApi.createUser(values)).data;
    },
  });
};
